import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BasePlate } from '../components/base-plate/Component.js';

var styles = {"bold":"plate__bold_v350i","description":"plate__description_v350i","footer":"plate__footer_v350i","rounded":"plate__rounded_v350i","shadow":"plate__shadow_v350i"};
require('./desktop.css')

var PlateDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BasePlate, __assign({}, restProps, { styles: styles, ref: ref }))); });

export { PlateDesktop };
